<template>
	<div id="page">

		<!-- 页头 -->
		<pagehead ref="child" />

		<!-- 占高盒 -->
		<div class="pager">
			<!-- 个人中心盒子 -->
			<div class="mineBox df dfsb w1k2 mauto">
				<!-- 左侧内容 -->
				<mineleft />
				<!-- 右侧内容 -->
				<div class="mineBoxR f1 ml25">
					<!-- 上面卡片 -->
					<el-tabs type="border-card" class="repwd">
						<el-tab-pane label="修改密码">
							<!-- 卡片内容 -->
							<template>
								<!-- 用户信息 -->
								<div class="userInfo plr10">
									<!-- 信息列表 -->
									<div v-if="!isNewUser" class="userInfoList df">
										<div class="userInfoListL">旧密码</div>
										<div class="userInfoListR"><el-input v-model="nowpwd" placeholder="请输入旧密码"></el-input></div>
									</div>
									<div class="userInfoList df">
										<div class="userInfoListL">新密码</div>
										<div class="userInfoListR"><el-input v-model="newpwd" placeholder="请输入新密码" show-password></el-input></div>
									</div>
									<div class="userInfoList df">
										<div class="userInfoListL">确认密码</div>
										<div class="userInfoListR"><el-input v-model="repwd" placeholder="再次输入密码" show-password></el-input></div>
									</div>
									<!-- 列表结束 -->
								</div>
								<!-- 修改密码按钮 -->
								<div class="repwdBtn">
									<el-button type="primary" @click="changePwd">修改密码</el-button>
								</div>
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>

		<!-- 页脚 -->
		<pagefoot />

	</div>
</template>
<script>
	// 全局变量
	var that;
	export default{
		// 页面变量
		data() {
			return {
        isNewUser: false,
				// 现用密码
				nowpwd: '',
				// 新密码
				newpwd: '',
				// 再次密码
				repwd: '',
			}
		},

		// 实例化后
		created() {
			that = this;
      that.request({
        url: '/api/member/if_new?memberId='+localStorage.getItem("memberId"),
        // 调用成功
        success(rs){
          // 返回成功
          that.isNewUser=rs
        }
      })

		},

		activated(e){

			if(that.$route.query.login){
				that.$refs.child.loginAlert = true;
			}

		},

		// 方法集
		methods:{

			// 修改密码
			changePwd(){

				// 判断两次输入密码是否一致
				if(that.newpwd != that.repwd){
					// 弹窗提示用户
					that.$message.warning('两次输入密码不一致');
					return ;
				};

				// 请求接口 修改密码
				that.request({
					url: '/api/member/updatePwd',
					// 上传数据
					data:{
						// 会员id
						memberId: localStorage.getItem("memberId"),
						// 老密码
						oldPwd: that.nowpwd,
						// 新密码
						newPwd: that.newpwd,
					},
					// 调用成功
					success(rs){
						// 返回成功
						if(rs.code == 200){
							//弹窗提示用户
							that.$message.success('修改成功,请牢记您的新密码');
							// 清空input值
							that.nowpwd = that.newpwd = that.repwd = '';

							// 退出登录
							that.$refs.child.backLogin();

						}else{
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},
		},
	};
</script>
<style>
/* 左侧盒子 */
.mineBoxL {
	width: 170px;
}
/* 用户头像 */
.userPhoto {
	width: 36px;
	height: 36px;
}
/* 用户等级 */
.userLevel {
	width: 46px;
	height: 18px;
}
/* 用户等级文字 */
.userLevelTxt {
	right: 3px;
	line-height: 18px;
}
/* 左盒子列表 */
.mineBoxLB ul li {
	display: flex;
	justify-content: space-between;
	padding: 15px 20px;
	text-indent: 20px;
	color: #333;
	font-size: 14px;
}
/* 左盒子列表更多箭头 */
.mineBoxLB ul li .more {
	opacity: 0;
	transition: .2s;
}
/* 左侧盒子鼠标经过 */
.mineBoxLB ul li:hover {
	color: #0066dd;
	background-color: #F6FAFF;
}
/* 左侧盒子鼠标经过更多箭头 */
.mineBoxLB ul li:hover .more {
	opacity: 1;
}
/* 左侧盒子选中样式 */
.mineBoxLB ul li.active {
	color: #0066dd;
	background-color: #F6FAFF;
}
/* 左盒子列表更多箭头 */
.mineBoxLB ul li.active .more {
	opacity: 1;
}

/* 修改密码 */
.repwd {
	height: 450px;
}
/* 用户信息列表 */
.userInfoList {
	margin-top: 12px;
	align-items: center;
}
/* 用户信息列表左 */
.repwd .userInfoListL {
	width: 100px;
	line-height: 40px;
	text-align: right;
}
/* 用户信息列表左 */
.repwd .userInfoListR {
	margin-left: 25px;
}
.repwd .userInfoListR .el-input__inner {
	width: 400px;
}
/* 用户信息列表左右 */
.userInfoListL,
.userInfoListR {
	/* color: #666; */
	font-size: 14px;
}
/* 头部选项卡 */
.mineBoxR .el-tabs__item {
	font-size: 16px;
	font-weight: bold;
	height: 60px;
	line-height: 60px;
}
/* 顶部选中样式 */
.mineBoxR .el-tabs__item.is-top.is-active {
	color: #333;
}

/* 修改密码按钮 */
.repwdBtn {
	margin-top: 50px;
	margin-left: 250px;
}
.repwdBtn .el-button.el-button--primary {
	width: 160px;
	background-color: #0060DD;
}
</style>
